export default __webpack_public_path__ + "static/Pala_4-f0bb95c278d320f9ae7938abb3f8d265.png";